import {
  type AccessDecisionDto,
  AccessDecisionDtoRoutesEnum,
} from '@b-stock/account-api-client'

/** How a buyer holds AT&T access, as sent on analytics events (FR-015). */
export type AttAccessRoute = AccessDecisionDtoRoutesEnum | 'NONE' | 'DENIED'

/** When a buyer holds several routes, the first of these is reported. */
const ROUTE_PRECEDENCE: readonly AccessDecisionDtoRoutesEnum[] = [
  AccessDecisionDtoRoutesEnum.Legacy,
  AccessDecisionDtoRoutesEnum.KeyBuyer,
  AccessDecisionDtoRoutesEnum.AllowList,
]

/**
 * The analytics route for an AT&T access decision: undefined with no decision or when it is not
 * enforced (the event then carries no property), DENIED when a deny entry exists, else the first
 * held route by precedence, else NONE.
 */
export const toAttAccessRoute = (
  decision:
    | Pick<AccessDecisionDto, 'enforced' | 'denied' | 'routes'>
    | null
    | undefined
): AttAccessRoute | undefined => {
  if (decision?.enforced !== true) return undefined
  if (decision.denied) return 'DENIED'
  return (
    ROUTE_PRECEDENCE.find((route) => decision.routes.includes(route)) ?? 'NONE'
  )
}

/** `{ attAccessRoute }` when there is a route to report, else `{}`, for spreading into an event. */
export const attAccessRouteProperty = (
  route: AttAccessRoute | undefined
): { attAccessRoute?: AttAccessRoute } =>
  route ? { attAccessRoute: route } : {}
